import { StitchError } from "../../src/spec/errors.js";
import { Screen } from "./screen.js";
import { DesignSystem } from "./designsystem.js";
/** A Stitch project containing screens. */
export class Project {
    client;
    projectId;
    data;
    constructor(client, data) {
        this.client = client;
        {
            let _v = typeof data === "string" ? data : data.name;
            if (typeof _v === "string" && _v.startsWith("projects/"))
                _v = _v.slice(9);
            this.projectId = _v;
        }
        this.data = typeof data === "object" ? data : undefined;
    }
    /** Convenience alias for projectId */
    get id() {
        return this.projectId;
    }
    /**
     * Generates a new screen within a project from a text prompt.
     * Tool: generate_screen_from_text
     */
    async generate(prompt, deviceType, modelId) {
        try {
            const raw = await this.client.callTool("generate_screen_from_text", { projectId: this.projectId, prompt, deviceType, modelId });
            const _projected = (raw?.outputComponents ?? []).find((c) => c?.design?.screens != null)?.design?.screens?.[0];
            if (!_projected)
                throw new StitchError({ code: "UNKNOWN_ERROR", message: "Incomplete API response from generate_screen_from_text: expected object at projection path", recoverable: false });
            return new Screen(this.client, { ..._projected, projectId: this.projectId });
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Lists all screens within a given Stitch project.
     * Tool: list_screens
     */
    async screens() {
        try {
            const raw = await this.client.callTool("list_screens", { projectId: this.projectId });
            return (raw?.screens || []).map((item) => new Screen(this.client, { ...item, projectId: this.projectId }));
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Retrieves the details of a specific screen within a project.
     * Tool: get_screen
     */
    async getScreen(screenId) {
        try {
            const raw = await this.client.callTool("get_screen", { projectId: this.projectId, screenId, name: `projects/${this.projectId}/screens/${screenId}` });
            return new Screen(this.client, { ...raw, projectId: this.projectId });
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Creates a new design system for a project. Use this tool when the user wants to set or update the overall visual theme, style, or branding of the application.
     * Tool: create_design_system
     */
    async createDesignSystem(designSystem) {
        try {
            const raw = await this.client.callTool("create_design_system", { projectId: this.projectId, designSystem });
            return new DesignSystem(this.client, { ...raw, projectId: this.projectId });
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /**
     * Lists all design systems for a given project.
     * Tool: list_design_systems
     */
    async listDesignSystems() {
        try {
            const raw = await this.client.callTool("list_design_systems", { projectId: this.projectId });
            return (raw?.designSystems || []).map((item) => new DesignSystem(this.client, { ...item, projectId: this.projectId }));
        }
        catch (error) {
            throw StitchError.fromUnknown(error);
        }
    }
    /** Create a DesignSystem handle from an existing ID without an API call. */
    designSystem(id) {
        return new DesignSystem(this.client, { name: id, projectId: this.projectId });
    }
    /** Create a Screen handle from an existing ID without an API call. */
    screen(id) {
        return new Screen(this.client, { id: id, projectId: this.projectId });
    }
}
//# sourceMappingURL=project.js.map